/**
 * Maps refCodes to gatheringIds
 */
export const biDirectionalGatheringRefCodeLookup: Record<string, string> = {};
